module.exports = __webpack_public_path__ + "img/step1.eb822ee3.jpg";